import React from 'react';
import * as _ from 'lodash';

/*
  Says what the limits of the simulation are now: whether it is on, how many runs are active, and how big a run can be. When the
  limit is reached and the server said which run is in the way (`blockingRunId`, from the refusal), it names that run, which opens.
*/
export const LimitsBanner = ({ limits, blockingRunId, onOpenRun }) => {
    if (!limits) {
        return null;
    }
    const { enabled, runningRuns, maxConcurrentRuns } = limits;

    if (!enabled) {
        return (
            <div className={'sim-banner error'}>
                <i className={'material-icons'}>block</i>
                <div>
                    The simulation is switched off. New runs are refused until
                    it is switched back on. Runs that finished can still be
                    looked at.
                </div>
            </div>
        );
    }

    const full = maxConcurrentRuns > 0 && runningRuns >= maxConcurrentRuns;

    return (
        <div className={'sim-banner ' + (full ? 'warning' : 'info')}>
            <i className={'material-icons'}>
                {full ? 'hourglass_empty' : 'info'}
            </i>
            <div>
                {_.isNil(runningRuns) ? '' : `${runningRuns} of `}
                {maxConcurrentRuns} runs can be active at once
                {full ? ': a new run is refused until one finishes' : ''}.
                {full && blockingRunId && (
                    <span>
                        {' '}
                        The one in the way is{' '}
                        {onOpenRun ? (
                            <button
                                type={'button'}
                                className={'sim-link'}
                                onClick={() => onOpenRun(blockingRunId)}
                            >
                                run #{blockingRunId}
                            </button>
                        ) : (
                            `run #${blockingRunId}`
                        )}
                        .
                    </span>
                )}{' '}
                A run is up to {limits.maxEventsPerRun} events, played at up to{' '}
                {limits.maxEventsPerSecond} events a second.
            </div>
        </div>
    );
};
